import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersModule } from './users/users.module';
import { AuthModule } from './auth/auth.module';
import { TransactionsModule } from './admin/transactions/transactions.module';

@NgModule({
    imports: [
        CommonModule,
        AuthModule,
        UsersModule,
        TransactionsModule,
    ],
})
export class FeaturesModule {}
